import script from "./AllTokens.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllTokens.vue?vue&type=script&setup=true&lang=ts"

import "./AllTokens.vue?vue&type=style&index=0&id=1c067e52&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c067e52"]])

export default __exports__